export default {"src":"/_next/static/media/call_calling.3ecfbe85.svg","height":22,"width":22};